import { useState } from "react";

import Footer from "../../component/footer";
import Navbar from "../../component/navbar";
import { useNavigate } from "react-router-dom";
import Modal from "../../component/modal";
import Fancybox from "../../component/Fancybox";

export default function PageHR() {
  const navigate = useNavigate();
  const options = {
    margin: 10,
    responsiveClass: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    navText: [
      '<span class="custom-nav-btn">&larr; Prev</span>',
      '<span class="custom-nav-btn">Next &rarr;</span>',
    ],
    responsive: {
      0: { items: 1, nav: true },
      600: { items: 3, nav: false },
      1000: { items: 3, nav: false },
    },
  };
  const [titleModal, setTitleModal] = useState("");
  // const [linkDownload, setLinkDownload] = useState("");
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);

  const HolidayCalendar = () => {
    return (
      <>
        <Fancybox
          options={{
            Carousel: {
              infinite: false,
            },
          }}
        >
          <button
            data-fancybox="gallery"
            href="/Calendar/วันหยุดราชการปี 68.jpg"
            className="w-20 bg-gradient-to-tl from-[#9e76b4] to-[#5c4d8b] hover:bg-gradient-to-tl hover:from-pink-500 hover:to-indigo-600 text-white font-bold py-2 px-4 rounded"
          >
            <p className="text-[12px]">วันหยุดราชการปี 2568</p>
          </button>
        </Fancybox>
      </>
    );
  };

  const dataLinkYoutube = [
    {
      id: 1,
      title: "ประเภทการลาของพนักงาน",
      link: "https://www.youtube.com/embed/Z36JSjibJcQ",
    },
    {
      id: 2,
      title: "HR VET CMU คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่",
      link: "https://www.youtube.com/embed/1wEic0T7EAg",
    },
  ];

  return (
    <>
      <Navbar />
      <div className="relative">
        <div className="h-screen max-w-7xl mx-auto container pt-10 mb-[600px]">
          <div
            className="grid grid-cols-2 md:flex-row gap-5 owl-theme  p-5"
            {...options}
          >
            <div
              onClick={() =>
                window.open(
                  "https://mis.cmu.ac.th/cmumis/download/ManualCMUHR/HRReqCertManual.pdf",
                  "_blank",
                )
              }
              className="relative shadow-md bg-[#9e76b450] px-5 py-5 hover:bg-[#9e76b4] transition-all duration-300 text-[#9e76b4]  hover:text-white rounded-lg flex items-center justify-center  h-36 cursor-pointer"
            >
              <div className="w-16 h-16 absolute top-0 left-0">
                <img src="/logoHR.png" alt="" />
              </div>
              <span className="text-xl font-bold ">
                การขอหนังสือรับรองออนไลน์
              </span>
            </div>
            <div
              onClick={() => {
                navigate("/pages/academic/flex");
              }}
              className="relative shadow-md bg-[#9e76b450] px-5 py-5 hover:bg-[#9e76b4] transition-all duration-300 text-[#9e76b4] hover:text-white rounded-lg flex items-center justify-center  h-36 cursor-pointer"
            >
              <div className="w-16 h-16 absolute top-0 left-0">
                <img src="/logoHR.png" alt="" />
              </div>
              <span className="text-xl font-bold ">
                สวัสดิการด้านสุขภาพแบบยืดหยุ่น
              </span>
            </div>
            <div
              onClick={() => navigate("/pages/academic/ประกันสุขภาพ")}
              className="relative shadow-md bg-[#9e76b450] px-5 py-5 hover:bg-[#9e76b4] transition-all duration-300 text-[#9e76b4] hover:text-white rounded-lg flex items-center justify-center  h-36 cursor-pointer"
            >
              <div className="w-16 h-16 absolute top-0 left-0">
                <img src="/logoHR.png" alt="" />
              </div>
              <span className="text-xl font-bold ">
                ประกันสุขภาพบุคลากร ปีงบประมาณ 2568
              </span>
            </div>
            <div
              onClick={() => navigate("/pages/academic/VL/page")}
              className="relative shadow-md bg-[#9e76b450] px-5  hover:bg-[#9e76b4] transition-all duration-300 text-[#9e76b4] hover:text-white rounded-lg flex items-center justify-center  h-36 cursor-pointer"
            >
              <div className="w-16 h-16 absolute top-0 left-0">
                <img src="/logoHR.png" alt="" />
              </div>
              <span className="text-xl font-bold ">
                การลาเดินทางไปต่างประเทศ (ส่วนตัว)
              </span>
            </div>
          </div>
          <hr className="border-t-1 border-[#9e76b450]" />
          {/* การขอตำแหน่งทางวิชาการ */}
          <div className="w-full flex flex-col gap-5 px-5">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
              <div
                onClick={() => navigate("/pages/academic/page")}
                className="hover:scale-105 rounded-lg hover:shadow-sm hover:border flex flex-col items-center 
            justify-center cursor-pointer text-center text-[#9e76b4]  duration-500 transition ease-in-out 
            hover:bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] hover:text-white hover:no-underline space-y-3 py-3"
              >
                <div className="border-2 rounded-full w-24 h-24 overflow-hidden p-3 border-white bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] shadow-md shadow-gray-400">
                  <img
                    className="object-cover mx-auto"
                    src="https://img.icons8.com/?size=100&id=qiN50t8sHZsy&format=png&color=000000"
                    alt="not img"
                  />
                </div>
                <div className="text-xl">การขอตำแหน่งทางวิชาการ</div>
              </div>
              <div
                onClick={() => navigate("/pages/academic/research")}
                className="hover:scale-105 rounded-lg hover:shadow-sm hover:border flex flex-col items-center 
            justify-center cursor-pointer text-center text-[#9e76b4]  duration-500 transition ease-in-out 
            hover:bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] hover:text-white hover:no-underline space-y-3 py-3"
              >
                <div className="border-2 rounded-full w-24 h-24 overflow-hidden p-3 border-white bg-gradient-to-b from-[#9e76b4] to-[#5eafd2] shadow-md shadow-gray-400">
                  <img
                    className="object-cover  mx-auto"
                    src="https://img.icons8.com/?size=100&id=12150&format=png&color=000000"
                    alt="not img"
                  />
                </div>
                <div className="text-xl">การกำหนดตำแหน่งนักวิจัย</div>
              </div>
              <div
                onClick={() => navigate("/pages/academic/high-positioning")}
                className="hover:scale-105 rounded-lg hover:shadow-sm hover:border flex flex-col items-center 
            justify-center cursor-pointer text-center text-[#9e76b4]  duration-500 transition ease-in-out 
            hover:bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] hover:text-white hover:no-underline space-y-3 py-3"
              >
                <div className="border-2 rounded-full w-24 h-24 overflow-hidden p-3 border-white bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] shadow-md shadow-gray-400">
                  <img
                    className="object-cover mx-auto"
                    src="https://img.icons8.com/?size=100&id=102554&format=png&color=000000"
                    alt="not img"
                  />
                </div>
                <div className="text-xl ">การกำหนดตำแหน่งที่สูงขึ้น</div>
              </div>
              <div
                onClick={() => navigate("/pages/academic/tor-ja")}
                className="hover:scale-105 rounded-lg hover:shadow-sm hover:border flex flex-col items-center 
            justify-center cursor-pointer text-center text-[#9e76b4]  duration-500 transition ease-in-out 
            hover:bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] hover:text-white hover:no-underline space-y-3 py-3"
              >
                <div className="border-2 rounded-full w-24 h-24 overflow-hidden p-3 border-white bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] shadow-md shadow-gray-400">
                  <img
                    className="object-cover mx-auto"
                    src="https://img.icons8.com/?size=100&id=11815&format=png&color=000000"
                    alt="not img"
                  />
                </div>
                <div className="text-xl ">การกรอกภาระงาน TOR-JA</div>
              </div>
              <div
                onClick={() =>
                  window.open(
                    "https://general.vet.cmu.ac.th/PAPER/CNX-1.doc",
                    "_blank",
                  )
                }
                className="hover:scale-105 rounded-lg hover:shadow-sm hover:border flex flex-col items-center 
            justify-center cursor-pointer text-center text-[#9e76b4]  duration-500 transition ease-in-out 
            hover:bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] hover:text-white hover:no-underline space-y-3 py-3"
              >
                <div className="border-2 rounded-full w-24 h-24 overflow-hidden p-3 border-white bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] shadow-md shadow-gray-400">
                  <img
                    className="object-cover mx-auto"
                    src="https://img.icons8.com/?size=100&id=11815&format=png&color=000000"
                    alt="not img"
                  />
                </div>
                <div className="text-xl ">ขออนุมัติเดินทางอบรมฯ เชียงใหม่</div>
              </div>
              <div
                onClick={() =>
                  window.open(
                    "https://general.vet.cmu.ac.th/PAPER/upcountry-1.doc",
                    "_blank",
                  )
                }
                className="hover:scale-105 rounded-lg hover:shadow-sm hover:border flex flex-col items-center 
            justify-center cursor-pointer text-center text-[#9e76b4]  duration-500 transition ease-in-out 
            hover:bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] hover:text-white hover:no-underline space-y-3 py-3"
              >
                <div className="border-2 rounded-full w-24 h-24 overflow-hidden p-3 border-white bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] shadow-md shadow-gray-400">
                  <img
                    className="object-cover mx-auto"
                    src="https://img.icons8.com/?size=100&id=11815&format=png&color=000000"
                    alt="not img"
                  />
                </div>
                <div className="text-xl ">
                  ขออนุมัติเดินทางอบรมฯ ต่างจังหวัด
                </div>
              </div>
              <div
                onClick={() =>
                  window.open(
                    "https://general.vet.cmu.ac.th/SOP/SOP_FULL.pdf",
                    "_blank",
                  )
                }
                className="hover:scale-105 rounded-lg hover:shadow-sm hover:border flex flex-col items-center 
            justify-center cursor-pointer text-center text-[#9e76b4]  duration-500 transition ease-in-out 
            hover:bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] hover:text-white hover:no-underline space-y-3 py-3"
              >
                <div className="border-2 rounded-full w-24 h-24 overflow-hidden p-3 border-white bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] shadow-md shadow-gray-400">
                  <img
                    className="object-cover mx-auto"
                    src="https://img.icons8.com/?size=100&id=11815&format=png&color=000000"
                    alt="not img"
                  />
                </div>
                <div className="text-xl ">ลาศึกษาต่อ (เต็มเวลา)</div>
              </div>
              <div
                onClick={() =>
                  window.open(
                    "https://general.vet.cmu.ac.th/SOP/SOP_2.pdf",
                    "_blank",
                  )
                }
                className="hover:scale-105 rounded-lg hover:shadow-sm hover:border flex flex-col items-center 
            justify-center cursor-pointer text-center text-[#9e76b4]  duration-500 transition ease-in-out 
            hover:bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] hover:text-white hover:no-underline space-y-3 py-3"
              >
                <div className="border-2 rounded-full w-24 h-24 overflow-hidden p-3 border-white bg-gradient-to-t from-[#9e76b4] to-[#5eafd2] shadow-md shadow-gray-400">
                  <img
                    className="object-cover mx-auto"
                    src="https://img.icons8.com/?size=100&id=11815&format=png&color=000000"
                    alt="not img"
                  />
                </div>
                <div className="text-xl ">ลาศึกษาต่อ (ไม่ใช่เวลาราชการ)</div>
              </div>
            </div>
          </div>
          {/* การขอตำแหน่งทางวิชาการ */}
          <hr className="border-t-1 border-[#9e76b450]" />
          {/* Banner Section */}
          <div className="flex flex-col items-start justify-center space-y-3">
            <div className="flex justify-center items-center gap-2 text-3xl text-[#9e76b4] font-bold">
              <i className="fa fa-user"></i>
              <p>การขออนุมัติลาศึกษาต่อในประเทศโดยไม่ใช่เวลาราชการ</p>
            </div>
            <div className=" shadow-md shadow-gray-400 rounded-lg overflow-hidden">
              <img
                className="object-cover w-full"
                src="/SOP/SOP_2.png"
                alt=""
              />
            </div>
          </div>
          {/* Banner Section */}
          <hr className="border-t-1 border-[#9e76b450]" />
          {/* banner person */}
          <div className="flex flex-col items-start justify-center space-y-3">
            <div className="flex justify-center items-center gap-2 text-3xl text-[#9e76b4] font-bold">
              <i className="fa fa-user"></i>
              <p>การขออนุมัติลาศึกษาต่อในประเทศและต่างประเทศ (เต็มเวลา)</p>
            </div>
            <div className=" shadow-md shadow-gray-400 rounded-lg overflow-hidden mx-auto">
              <img
                className="object-cover w-full "
                src="/SOP/SOP_FULL.png"
                alt=""
              />
            </div>
          </div>
          {/* 
          <Fancybox
            options={{
              Carousel: {
                infinite: false,
              },
            }}
          >
            <div className="flex justify-between space-x-5">
              <div
                data-fancybox="gallery"
                href="/2.jpg"
                className="overflow-hidden rounded-md  transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <img src="/2.jpg" className="object-cover" alt="" />
              </div>
              <div
                data-fancybox="gallery"
                href="/3.jpg"
                className="overflow-hidden rounded-md  transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <img src="/3.jpg" className="object-cover" alt="" />
              </div>
              <div
                data-fancybox="gallery"
                href="/4.jpg"
                className="overflow-hidden rounded-md  transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <img src="/4.jpg" className="object-cover" alt="" />
              </div>
              <div
                data-fancybox="gallery"
                href="/5.jpg"
                className="overflow-hidden rounded-md  transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <img src="/5.jpg" className="object-cover" alt="" />
              </div>
              <div
                data-fancybox="gallery"
                href="/6.jpg"
                className="overflow-hidden rounded-md  transition-all duration-300 hover:scale-105 cursor-pointer"
              >
                <img src="/6.jpg" className="object-cover" alt="" />
              </div>
            </div>
          </Fancybox> */}

          {/* banner person */}
          <hr className="border-t-1 border-[#9e76b450]" />
          {/* Video Section */}
          <div className="flex flex-col items-start justify-center space-y-5 pb-[200px]">
            <div className="flex justify-center items-center gap-2 text-3xl text-[#9e76b4] font-bold">
              <img
                className="w-10 h-10 object-cover"
                src="https://img.icons8.com/?size=100&id=Uu6z6IbXGn1K&format=png&color=000000"
                alt=""
              />
              <p>Channel</p>
            </div>
            <div className=" grid grid-cols-1 md:grid-cols-2 gap-2 text-xl text-[#5eafd2]">
              {dataLinkYoutube.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center justify-center"
                >
                  <iframe
                    src={item.link}
                    className="w-full h-full rounded-xl"
                    style={{ border: "none" }}
                    allowFullScreen
                    title="YouTube Video"
                  ></iframe>
                  <span>{item.title}</span>
                </div>
              ))}
            </div>
          </div>
          {/* Video Section */}
        </div>

        <div className="fixed top-1/2 right-1 ">
          {/* <HolidayCalendar /> */}
        </div>
        <div>
          <Modal
            id="default-modal"
            title={titleModal ?? ""}
            size="max-w-4xl"
            linkDownload={""}
            show={showModal}
            onClose={closeModal}
          >
            <div className="h-[500px] w-full overflow-y-scroll custom-scrollbar">
              <img
                src="/Calendar/วันหยุดราชการปี 68.jpg"
                className="object-cover "
                alt=""
              />
            </div>
          </Modal>
        </div>
      </div>
      {/* <Cookie /> */}
      <Footer />
    </>
  );
}
